import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpenTaskInfoIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 9.375,
			fill: "#0055D4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 15V8.75",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 4.375C10.1236 4.375 10.2445 4.41166 10.3472 4.48033C10.45 4.54901 10.5301 4.64662 10.5774 4.76082C10.6247 4.87503 10.6371 5.00069 10.613 5.12193C10.5889 5.24317 10.5294 5.35453 10.4419 5.44194C10.403 5.48086 10.3594 5.51425 10.3122 5.54145C10.2534 5.57534 10.1892 5.59961 10.1219 5.61299C10.0007 5.63711 9.87503 5.62473 9.76082 5.57742C9.64662 5.53012 9.54901 5.45001 9.48033 5.34723C9.41166 5.24445 9.375 5.12361 9.375 5C9.375 4.83424 9.44085 4.67527 9.55806 4.55806C9.67527 4.44085 9.83424 4.375 10 4.375Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgOpenTaskInfoIcon);
export default ForwardRef;
